import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import ClearIcon from '@mui/icons-material/Clear';

import {
   TimePicker as MuiTimePicker,
   TimePickerProps as MuiTimePickerProps,
} from '@mui/x-date-pickers/TimePicker';
import TextField from '@mui/material/TextField';
import React from 'react';
import {useController, useFormContext} from 'react-hook-form';
import {SetValueOptions} from 'components/hook-form/helpers';
import dayjs from 'dayjs';
import {useRegisterLabel} from 'common/context/FormContext';

type TimePickerProps = {value?: any; name: string} & Partial<MuiTimePickerProps<Date, Date>>;

type Props = TimePickerProps & {
   touched: boolean;
   setValue: (value?: Date | string | null) => void;
   error?: boolean;
};

const _TimePicker = ({name, setValue, value, touched, error, onChange, ...restProps}: Props) => {
   const hasError = Boolean(touched && error);
   const hasClearIcon = Boolean(value && !restProps.disabled);
   const handleChange = (date: Date | null) => {
      // if (onChange && date) {
      //    onChange((date as Dayjs).toDate());
      //    return;
      // }
      if (date) {
         try {
            setValue(dayjs(date).millisecond(0).toISOString());
         } catch {}
      }
   };

   return (
      <MuiTimePicker
         // inputFormat={dateTimeFormatMoment}
         // name={name}
         value={value}
         {...restProps}
         renderInput={(props) => (
            <TextField
               name={name}
               fullWidth
               {...props}
               error={hasError}
               helperText={hasError ?? error}
            />
         )}
         InputProps={{
            endAdornment: hasClearIcon && (
               <InputAdornment position="end">
                  <IconButton
                     size="small"
                     onClick={(e) => {
                        e.stopPropagation();
                        setValue(null);
                     }}
                  >
                     <ClearIcon fontSize="small" />
                  </IconButton>
               </InputAdornment>
            ),
         }}
         onChange={handleChange}
      />
   );
};

const HookFormDatePicker = ({name, onChange, ...restProps}: TimePickerProps) => {
   const methods = useController({
      name,
   });

   const {
      field: {onChange: fieldOnChange, value},
      fieldState: {error: _error, isTouched},
   } = methods;
   const {setValue} = useFormContext();
   useRegisterLabel(name, restProps.label as string);
   return (
      <_TimePicker
         name={name}
         value={value || ''}
         onChange={fieldOnChange}
         setValue={(val) => setValue(name, val, SetValueOptions)}
         error={!!_error?.message}
         touched={isTouched}
         {...restProps}
      />
   );
};

export default React.memo(HookFormDatePicker);
